import axios from 'axios'
import * as PID from './Protocal'

const BASE_URL  = process.env.REACT_APP_API_URL ?? 'http://localhost:5031'
const ServerUrl = `${BASE_URL}/Main/Proc`
const DELIM = '\x18'

export interface ApiResult {
  resultCode:    string
  resultMessage: string
  resultData:    string
  rowCount:      number
  dataType:      number
  columnName:    string
  columnType:    string
}

async function httpPost(proc: string, requestData: string, token = ''): Promise<ApiResult> {
  const body = {
    token,
    sendTime:   new Date().toISOString().replace('T', ' ').slice(0, 19),
    proc,
    requestData,
    paramCount: requestData ? requestData.split(DELIM).length : 0,
  }
  const res = await axios.post<ApiResult>(ServerUrl, body)
  const data = res.data
  if (
    token &&
    (data.resultCode === '97' || data.resultMessage === '세션이 만료되었습니다.')
  ) {
    window.dispatchEvent(new CustomEvent('session-expired'))
  }
  return data
}

// 사용자
export const apiUserRegister = (userId: string, userPass: string, userName: string) =>
  httpPost(PID.PID_USER_REGISTER, [userId, userPass, userName].join(DELIM))
export const apiUserLogin = (userId: string, userPass: string) =>
  httpPost(PID.PID_USER_LOGIN, [userId, userPass].join(DELIM))
export const apiUserLogout = (token: string) =>
  httpPost(PID.PID_USER_LOGOUT, '', token)

// 캐릭터/게임
export const apiCharLoad    = (token: string) => httpPost(PID.PID_CHAR_LOAD, '', token)
export const apiCharSave    = (token: string, gold: number, hp: number, region: string) =>
  httpPost(PID.PID_CHAR_SAVE, [gold, hp, region].join(DELIM), token)
export const apiTurnStatus  = (token: string) => httpPost(PID.PID_TURN_STATUS, '', token)
export const apiGameConfig  = () => httpPost(PID.PID_GAME_CONFIG, '')
export const apiRegionList  = (token = '') => httpPost(PID.PID_REGION_LIST, '', token)
export const apiHuntPlaceList = (regionId: string) => httpPost(PID.PID_HUNT_PLACE_LIST, regionId)

// 행동
export const apiActionStart  = (token: string, actionType: string, paramJson: string) =>
  httpPost(PID.PID_ACTION_START, [actionType, paramJson].join(DELIM), token)
export const apiActionCancel = (token: string) => httpPost(PID.PID_ACTION_CANCEL, '', token)
export const apiActionTick   = (token: string, globalTurn: number) =>
  httpPost(PID.PID_ACTION_TICK, String(globalTurn), token)

// 무공
export const apiMugongMaster = () => httpPost(PID.PID_MUGONG_MASTER, '')
export const apiMugongList   = (token: string) => httpPost(PID.PID_MUGONG_LIST, '', token)
export const apiMugongLearn  = (token: string, mugongId: string) =>
  httpPost(PID.PID_MUGONG_LEARN, mugongId, token)
export const apiMugongEquip  = (token: string, mugongId: string) =>
  httpPost(PID.PID_MUGONG_EQUIP, mugongId, token)

// 행낭
export const apiInvList    = (token: string) => httpPost(PID.PID_INV_LIST, '', token)
export const apiInvEquip   = (token: string, invId: number, slot: string) =>
  httpPost(PID.PID_INV_EQUIP, [invId, slot].join(DELIM), token)
export const apiInvUnequip = (token: string, invId: number) =>
  httpPost(PID.PID_INV_UNEQUIP, String(invId), token)
export const apiInvDrop    = (token: string, invId: number, qty: number) =>
  httpPost(PID.PID_INV_DROP, [invId, qty].join(DELIM), token)

// 상점
export const apiShopList = (token: string, regionId: string) =>
  httpPost(PID.PID_SHOP_LIST, regionId, token)
export const apiShopBuy  = (token: string, shopId: string, itemId: string, qty: number) =>
  httpPost(PID.PID_SHOP_BUY, [shopId, itemId, qty].join(DELIM), token)
export const apiShopSell = (token: string, invId: number, qty: number) =>
  httpPost(PID.PID_SHOP_SELL, [invId, qty].join(DELIM), token)

// 거래소
export const apiTradeList   = (token: string) => httpPost(PID.PID_TRADE_LIST, '', token)
export const apiTradePost   = (token: string, invId: number, qty: number, price: number) =>
  httpPost(PID.PID_TRADE_POST, [invId, qty, price].join(DELIM), token)
export const apiTradeBuy    = (token: string, orderId: number) =>
  httpPost(PID.PID_TRADE_BUY, String(orderId), token)
export const apiTradeCancel = (token: string, orderId: number) =>
  httpPost(PID.PID_TRADE_CANCEL, String(orderId), token)

// 문파
export const apiSectCreate      = (token: string, sectName: string, desc: string) =>
  httpPost(PID.PID_SECT_CREATE, [sectName, desc].join(DELIM), token)
export const apiSectInfo        = (token: string) => httpPost(PID.PID_SECT_INFO, '', token)
export const apiSectList        = () => httpPost(PID.PID_SECT_LIST, '')
export const apiSectApply       = (token: string, sectId: number, message: string) =>
  httpPost(PID.PID_SECT_APPLY, [sectId, message].join(DELIM), token)
export const apiSectAccept      = (token: string, applyId: number) =>
  httpPost(PID.PID_SECT_ACCEPT, String(applyId), token)
export const apiSectReject      = (token: string, applyId: number) =>
  httpPost(PID.PID_SECT_REJECT, String(applyId), token)
export const apiSectLeave       = (token: string) => httpPost(PID.PID_SECT_LEAVE, '', token)
export const apiSectStorageList = (token: string) => httpPost(PID.PID_SECT_STORAGE_LIST, '', token)
export const apiSectDeposit     = (token: string, invId: number, qty: number) =>
  httpPost(PID.PID_SECT_DEPOSIT, [invId, qty].join(DELIM), token)
export const apiSectWithdraw    = (token: string, stoId: number, qty: number) =>
  httpPost(PID.PID_SECT_WITHDRAW, [stoId, qty].join(DELIM), token)
export const apiSectApplyList       = (token: string) => httpPost(PID.PID_SECT_APPLY_LIST, '', token)

// 문파 비고
export const apiSectVaultList    = (token: string) => httpPost(PID.PID_SECT_VAULT_LIST, '', token)
export const apiSectVaultDeposit = (token: string, invId: number, qty: number) =>
  httpPost(PID.PID_SECT_VAULT_DEPOSIT, [invId, qty].join(DELIM), token)
export const apiSectVaultWithdraw = (token: string, vaultId: number, qty: number) =>
  httpPost(PID.PID_SECT_VAULT_WITHDRAW, [vaultId, qty].join(DELIM), token)

// 문파 운영비
export const apiSectFundDeposit  = (token: string, amount: number, memo: string) =>
  httpPost(PID.PID_SECT_FUND_DEPOSIT, [amount, memo].join(DELIM), token)
export const apiSectFundWithdraw = (token: string, amount: number, memo: string) =>
  httpPost(PID.PID_SECT_FUND_WITHDRAW, [amount, memo].join(DELIM), token)
export const apiSectFundLog      = (token: string) => httpPost(PID.PID_SECT_FUND_LOG, '', token)

// 연단 / 대장간
export const apiAlchemyRecipeList   = (token: string) => httpPost(PID.PID_ALCHEMY_RECIPE_LIST, '', token)
export const apiAlchemyCreate       = (token: string, recipeId: string, useSectStorage: 0 | 1 = 0) =>
  httpPost(PID.PID_ALCHEMY_CREATE, [recipeId, useSectStorage].join(DELIM), token)
export const apiCraftRecipeList     = (token: string) => httpPost(PID.PID_CRAFT_RECIPE_LIST, '', token)
export const apiCraftCreate         = (token: string, recipeId: string, useSectStorage: 0 | 1 = 0) =>
  httpPost(PID.PID_CRAFT_CREATE, [recipeId, useSectStorage].join(DELIM), token)

// 이동
export const apiCharMove = (token: string, regionId: string) =>
  httpPost(PID.PID_CHAR_MOVE, regionId, token)

// 마스터
export const apiItemMaster    = () => httpPost(PID.PID_ITEM_MASTER, '')
export const apiMonsterMaster = () => httpPost(PID.PID_MONSTER_MASTER, '')
export const apiMonsterList   = (placeId: string) => httpPost(PID.PID_MONSTER_MASTER, placeId)
export const apiHuntDropList  = (token: string, placeId: string) => httpPost(PID.PID_HUNT_DROP_LIST, placeId, token)
export const apiFortuneMaster = () => httpPost(PID.PID_FORTUNE_MASTER, '')

// 자동 소모품
export const apiAutoPotionSet   = (token: string, statType: 'HP' | 'NG', itemId: string, threshold: number) =>
  httpPost(PID.PID_AUTO_POTION_SET, [statType, itemId, threshold].join(DELIM), token)
export const apiAutoPotionQuery = (token: string) =>
  httpPost(PID.PID_AUTO_POTION_QUERY, '', token)

// 장비 강화
export const apiItemEnhance = (token: string, invId: number, scrollInvId: number) =>
  httpPost(PID.PID_ITEM_ENHANCE, [invId, scrollInvId].join(DELIM), token)

// 소모품 사용
export const apiUseItem = (token: string, invId: number) =>
  httpPost(PID.PID_USE_ITEM, String(invId), token)

// 랭킹
export const apiRankList     = (limit = 20) => httpPost(PID.PID_RANK_LIST, String(limit))
export const apiSectRankList = (limit = 20) => httpPost(PID.PID_SECT_RANK_LIST, String(limit))

// 이벤트
export const apiBloodCultStatus = () => httpPost(PID.PID_EVENT_BLOODCULT_STATUS, '')
export const apiBloodCultLatest = () => httpPost(PID.PID_EVENT_BLOODCULT_LATEST, '')
